(function () {
    'use strict';

    drvEntityTemplateList.$inject = [];
    drvEntityTemplateListCtrl.$inject = ['$scope', '$q', '$location', 'EntityTemplatesService', 'NavigationAidService', 'DialogService', 'SystemService'];

    angular
        .module('app')
        .directive('drvEntityTemplateList', drvEntityTemplateList);

    /**
     * @ngdoc directive
     * @name drvEntityTemplateList
     */
    function drvEntityTemplateList() {
        return {
            templateUrl: 'app/dashboard/entity-template-list.tmpl.html',
            scope: {
                label: '@',
                configuration: '='
            },
            controller: drvEntityTemplateListCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                configuration: '=',
                viewMode: '<?'
            }
        };
    }

    /**
     * @ngdoc controller
     * @name drvEntityTemplateListCtrl
     */
    function drvEntityTemplateListCtrl($scope, $q, $location, EntityTemplatesService, NavigationAidService, DialogService, SystemService) {
        /* jshint validthis:true */
        var drvCtrl = this;
        drvCtrl.allEntityTemplatesSelected = false;
        drvCtrl.templateCount = 0;
        drvCtrl.currentPage = 1;
        drvCtrl.newEntityTemplate = newEntityTemplate;
        drvCtrl.deleteEntityTemplate = deleteEntityTemplate;
        drvCtrl.templatePreview = templatePreview;
        drvCtrl.updateList = updateList;
        drvCtrl.loadCount = loadCount;
        drvCtrl.copyEntityTemplates = copyEntityTemplates;
        drvCtrl.deleteEntityTemplates = deleteEntityTemplates;
        drvCtrl.close = close;
        drvCtrl.loading = false;
        drvCtrl.error = null;
        drvCtrl.showDeleted = false;
        Object.defineProperty(drvCtrl, 'selectedEntityTemplates', {
            get: function () {
                return _(drvCtrl.entityTemplates)
                    .filter('Selected')
                    .value();
            }
        });
        Object.defineProperty(drvCtrl, 'titleText', { get: getTitleText });

        activate();

        function activate() {
            drvCtrl.searchDelay = SystemService.getSearchDelay();

            // Watch for update on generic search text, update list if it changes
            $scope.$watch('drvCtrl.genericSearch', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    updateList();
                }
            });

            $scope.$watch('drvCtrl.showDeleted', function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    updateList();
                    loadCount();
                }
            });

            updateList();
            loadCount();
        }

        function updateList(newPage) {
            if (updateList.currentPromise === undefined) {
                updateList.currentPromise = null;
            }
            drvCtrl.loading = true;

            var genericSearch = "";

            if (!angular.isUndefined(newPage)) {
                drvCtrl.currentPage = newPage;
            }

            if (!angular.isUndefined(drvCtrl.genericSearch)) {
                genericSearch = angular.copy(drvCtrl.genericSearch);
            }

            var query = {
                currentPage: drvCtrl.currentPage,
                genericSearch: genericSearch
            };

            if (!_.isNil(drvCtrl.configuration.ListPageSize)) {
                query.pageSize = drvCtrl.configuration.ListPageSize;
            }

            var getPromise = EntityTemplatesService.query(query)
                .then(getEntityTemplatesOk, getEntityTemplatesError)
                .then(function () {
                    drvCtrl.loading = false;
                });

            updateList.currentPromise = getPromise;

            return getPromise;

            function getEntityTemplatesOk(data) {
                if (getPromise === updateList.currentPromise) {
                    drvCtrl.error = null;
                    drvCtrl.allEntityTemplatesSelected = false;
                    drvCtrl.entityTemplates = data.EntityTemplates;
                    drvCtrl.templateCount = data.TemplateCount;
                }
                else {
                    return $q.reject();
                }
            }

            function getEntityTemplatesError(response) {
                if (getPromise === updateList.currentPromise) {
                    drvCtrl.error = response;
                }
                else {
                    return $q.reject();
                }
            }
        }

        function loadCount() {
            return EntityTemplatesService.count(drvCtrl.showDeleted)
                .then(loadCountOk, loadCountError);

            function loadCountOk(count) {
                drvCtrl.totalCount = count;
            }

            function loadCountError(response) {
            }
        }

        function deleteEntityTemplate(entityTemplate) {
            return DialogService.show({
                locals: { entityTemplateIds: [entityTemplate.Id], showCheckbox: false },
                controller: 'DeleteEntityTemplateDialogCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/entitytemplate/delete-entity-template-dialog.tmpl.html'
            }).then(function () {
                return EntityTemplatesService.deleteTemplate(entityTemplate.Id)
                        .then(deleteEntityTemplateOk)
                        .catch(deleteEntityTemplateError);
            });

            function deleteEntityTemplateOk(success) {
                drvCtrl.updateList();
                drvCtrl.loadCount();
            }

            function deleteEntityTemplateError(response) {
                DialogService.error('Error deleting Entity Template', response);
            }
        }

        function templatePreview(entityTemplate) {
            var preview = '';
            preview = entityTemplate.Description;

            return preview;
        }

        /**
         * Redirects to the new entity template route
         */
        function newEntityTemplate() {
            $location.url('/entitytemplates/new');
        }

        /**
         * Ensure at least one entity template is selected.
         * Displays a dialog 'No entity templates were selected' if no entity templates are selected.
         * @return {bool} true if at least one entity template is selected, else false
         */
        function ensureEntityTemplatesSelection() {
            if (drvCtrl.selectedEntityTemplates.length === 0) {
                DialogService.alert('No Entity Templates were selected');
                return false;
            } else {
                return true;
            }
        }

        /**
         * Copy the entity templates selected in the list.
         */
        function copyEntityTemplates() {
            var selectedEntityTemplateIds = _.map(drvCtrl.selectedEntityTemplates, 'Id');
            var entityTemplateLabel = 'Entity Template';
            if (selectedEntityTemplateIds.length > 1) {
                entityTemplateLabel += 's';
            }

            if (ensureEntityTemplatesSelection()) {
                DialogService
                    .confirm('Copy the ' + selectedEntityTemplateIds.length + ' selected ' + entityTemplateLabel + '?', 'Copy ' + entityTemplateLabel + ' confirm')
                    .then(copyEntityTemplatesConfirmed);
            }

            function copyEntityTemplatesConfirmed() {
                EntityTemplatesService.multiCopy(selectedEntityTemplateIds)
                   .then(copyOk, copyError);
            }

            function copyOk() {
                updateList();
                loadCount();
            }

            function copyError(response) {
                DialogService.error('Error copying ' + entityTemplateLabel, response);
                updateList();
            }
        }

        /**
         * Delete the entity templates selected in the list.
         */
        function deleteEntityTemplates() {
            var selectedEntityTemplateIds = _.map(drvCtrl.selectedEntityTemplates, 'Id');

            return DialogService.show({
                locals: { entityTemplateIds: selectedEntityTemplateIds, showCheckbox: true },
                controller: 'DeleteEntityTemplateDialogCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/entitytemplate/delete-entity-template-dialog.tmpl.html'
            }).then(function (entityTemplatesToDelete) {
                if (!_.isNil(entityTemplatesToDelete) && entityTemplatesToDelete.length > 0) {
                    return EntityTemplatesService.multiDelete(entityTemplatesToDelete)
                            .then(deleteEntityTemplatesOk, deleteEntityTemplatesError);
                }
            });

            function deleteEntityTemplatesOk(success) {
                updateList();
                loadCount();
            }

            function deleteEntityTemplatesError(response) {
                DialogService.error('Error deleting entity templates', response);
            }
        }

        /**
         * When the view is 'closed' navigation to a previous page should occur.
         */
        function close() {
            NavigationAidService.goBack();
        }

        /**
         * Gets the view title
         *
         * @returns {string}
         */
        function getTitleText() {
            var result = '';

            if (drvCtrl.showDeleted === true) {
                result += 'Deleted ';
            }

            result += 'Entity Templates';

            return result;
        }
    }

})();